import { createApiCall } from "services/api/createApiCall";
import { BillingItemKind, BillingItemType, Kpd } from "./types";
import { transformBillingItemKind, transformBillingItemType, transformKpd } from "./transformations";

/*---------------------------------------------------------------------------------------
   GET - BILLING ITEM KINDS
-----------------------------------------------------------------------------------------*/
export const getBillingItemKindsAPI = async (): Promise<BillingItemKind[]> => {
  const response = await createApiCall({
    path: "/v1/finance/lookups/billing/item-kinds",
    method: "GET",
  })();

  return response.data?.map(transformBillingItemKind) ?? [];
};

/*---------------------------------------------------------------------------------------
   GET - BILLING ITEM TYPES
-----------------------------------------------------------------------------------------*/
export const getBillingItemTypesAPI = async (kindId?: string | null): Promise<BillingItemType[]> => {
  const response = await createApiCall({
    path: `/v1/finance/lookups/billing/item-types${kindId ? `?kindId=${kindId}` : ""}`,
    method: "GET",
  })();

  return response.data?.map(transformBillingItemType) ?? [];
};

/*---------------------------------------------------------------------------------------
   GET - KPD
-----------------------------------------------------------------------------------------*/
/** Šifarnik ima stotine redaka, pa se uvijek dohvaća s pretragom i limitom. */
export const getKpdsAPI = async (search?: string | null, take: number = 50): Promise<Kpd[]> => {
  const params = new URLSearchParams();
  if (search) params.append("search", search);
  params.append("take", String(take));

  const response = await createApiCall({
    path: `/v1/finance/lookups/invoice/kpd?${params.toString()}`,
    method: "GET",
  })();

  return response.data?.map(transformKpd) ?? [];
};
